import React, { Fragment, FunctionComponent, useContext, useMemo } from 'react';
import { observer } from "mobx-react";
import { Context } from "../../../store/context";
import { DEFAULT_LANG } from "../../../store/constants";
import _ from 'lodash';
import { getNodeAndDestinationIdFromPkid } from '../../../utils/nodeDestinationUtils';

interface ITranslatedNodeDestination {
    id?: string;
}

const _TranslatedNodeDestination: FunctionComponent<ITranslatedNodeDestination> = ({ id }) => {
    const { nodesStore, defaultDestinationsStore, languagesStore } = useContext(Context);
    const { currentIETF } = languagesStore;
    const { nodes } = nodesStore;
    const { defaultDestinations } = defaultDestinationsStore;

    const [nodeId, destinationId] = getNodeAndDestinationIdFromPkid(id)

    const translation = useMemo(() => {
        if (!currentIETF || !nodes?.length || !defaultDestinations?.length)
            return nodeId;

        const node = nodes.find(n => n.id.toString() === nodeId);
        if (!node)
            return nodeId;

        let dest = node.destinations.find(d => d.destinationId.toString() === destinationId)

        if (!dest) {
            dest = _.first(node.destinations)
        }

        if (!dest) {
            return nodeId
        }

        const defDest = defaultDestinations.find(d => d.id === dest!.destinationId);
        if (!defDest) { return destinationId; }

        const ietfName = defDest.defaultDestinationNames.find(dn => dn.lang === currentIETF);
        if (ietfName) {
            return ietfName.name
        }

        const defLangName = defDest.defaultDestinationNames.find(dn => dn.lang === DEFAULT_LANG);
        if (defLangName) {
            return defLangName.name
        }
    }, [id, currentIETF, nodes, defaultDestinations]);

    return <Fragment>{translation}</Fragment>;
}

const TranslatedNodeDestination = observer(_TranslatedNodeDestination);
export default TranslatedNodeDestination;
